import React from 'react'

const ArtistDetails = () => {
  return (
    <div>
    </div>
  )
}

export default ArtistDetails